export const getTechno = (techno: string) => {
  switch (techno) {
    case "boul":
      return "la boulangerie";
    case "pat":
      return "la pâtisserie";
    case "char":
      return "la charcuterie";
    case "prim":
      return "primeur";
    case "cuis":
      return "la cuisine";
    default:
      return "";
  }
};

export const getType = (type: string) => {
  switch (type.toLocaleLowerCase()) {
    case "sciencesappliquees":
      return "Sciences Appliquées";
    case "gestionsappliquees":
      return "Gestion Appliquée";
    case "techno":
      return "Technologie";
    case "pse":
      return "PSE";
    case "synthese":
      return "Synthèse";
    case "annee1":
      return "Technologie T1";
    case "annee2":
      return "Technologie T2";
    default:
      return "--type--";
  }
};

export const mapBook = new Map([
  [
    "pat-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-techo-del2.pdf",
  ],
  [
    "pat-synthese",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-synthese-del.pdf",
  ],
  [
    "pat-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-pse-del.pdf",
  ],

  [
    "boul-sciencesappliquees",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-sciencesappliquees-del.pdf",
  ],
  ["boul-gestionsappliquees", ""],
  [
    "boul-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-techno-del.pdf",
  ],
  [
    "boul-synthese",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-synthese-del.pdf",
  ],
  [
    "boul-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-pse-del.pdf",
  ],

  [
    "char-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-pse-del.pdf",
  ],
  [
    "char-annee1",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-annee1-del.pdf",
  ],
  [
    "char-annee2",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-annee2-del.pdf",
  ],
  [
    "char-sciencesappliquees",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-sciencesappliquees-del.pdf",
  ],
  [
    "prim-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/prim-techno.pdf",
  ],
  [
    "cuis-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/cuisine/book/Livre+CAP+cuisine+page+par+page.pdf",
  ],
  [
    "cuis-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-pse-del.pdf",
  ],
]);
